<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/administrators/${this.$route.params.id}`,
                    },
                    {
                        title: 'Настройки',
                        url: `/administrators/${this.$route.params.id}/settings`,
                    },
                ],
            };
        },
    };
</script>
